export default function sanitizeContentEditableHtml(html, whitelistedTagNames = []) {
  const validEmptyTagNames = ['B', 'BR', 'DIV', 'I'];
  const validChildren = [];
  const invalidChildren = [];

  const wrapper = document.createElement('div');
  wrapper.innerHTML = html;

  // Edge does not support for..of loops on DOM node children
  for (let i = 0; i < wrapper.children.length; i++) {
    const child = wrapper.children[i];
    const whitelisted = whitelistedTagNames.indexOf(child.tagName) >= 0;
    const valid = whitelisted || (validEmptyTagNames.indexOf(child.tagName) >= 0 && child.attributes.length === 0);
    const collection = valid ? validChildren : invalidChildren;
    collection.push(child);
  }

  for (const child of validChildren) {
    child.innerHTML = sanitizeContentEditableHtml(child.innerHTML);
  }

  for (const child of invalidChildren) {
    const textNode = document.createTextNode(child.textContent);
    wrapper.replaceChild(textNode, child);
  }

  return wrapper.innerHTML;
}
